import { z } from 'zod';

// A CSP do app não permite eval (T-251b): o Zod valida sem compilar código (jitless), e não testa `new Function`
// — o teste dispara um bloqueio da CSP mesmo capturado. Importado primeiro no main.tsx, antes de qualquer validação.
z.config({ jitless: true });
